<template>
  <div v-if="visible" class="popup-fullscreen" :class="{ mobile: isMobile }">
    <div class="popup-wrapper">
      <img
        class="popup-image"
        :src="popupImage"
        alt="popup"
        @click="goToChat"
      />
      <span class="close-icon" @click="closePopup">×</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockAntsChatPopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    closePopup() {
      this.$emit('update:visible', false);
    },
     goToChat() {
      const profession = this.userProfile && this.userProfile.profession;
      console.log('User profession:', profession);
      if (profession === 'Retail Investor') {
        this.$router.push('/expert-list');
      } else {
        this.$router.push('/chat');
      }
    },
  },
   computed: {
    popupImage() {
      return this.isMobile
        ? require('@/assets/images/ChatImages/MobileChatPopup.svg')
        : require('@/assets/images/ChatImages/WebChatPopup.svg');
    },

     userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },
  watch: {
    visible(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    },
  },
};
</script>

<style scoped lang="scss">
.popup-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;

  &.mobile {
    padding: 0;

    .popup-wrapper {
      position: relative;
      width: 100vw;
      height: 100vh;

      .popup-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0;
        display: block;
       // margin-top: 40px;
      }

      .close-icon {
        position: absolute;
        top: 0;
        right: 0;
        margin: 8px;
        background: #fff;
        color: #333;
        font-size: 22px;
        font-weight: bold;
        border-radius: 50%;
        padding: 4px 10px;
        cursor: pointer;
        z-index: 10;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
      }
    }
  }

  .popup-wrapper {
    position: relative;
    display: inline-block;

    .popup-image {
      display: block;
      max-width: 100%;
      height: auto;
      border-radius: 16px;
      cursor: pointer;
    }

    .close-icon {
      position: absolute;
      top: 10px;
      right: 10px;
      background: #fff;
      color: #333;
      font-size: 20px;
      font-weight: bold;
      border-radius: 50%;
      padding: 2px 8px;
      cursor: pointer;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
      z-index: 2;
    }
  }
}
</style>